import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHeart,
  faCalendar,
  faBookmark,
  faUser,
} from "@fortawesome/free-regular-svg-icons";

library.add(faHeart, faCalendar, faBookmark, faUser);
